export default __webpack_public_path__ + "static/media/cowry-asa-1.5x.c5c4a4e5.png";